import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { EmailFolderSchema } from './folder.schema';

export const GetFoldersListResponseSchema = ListResponseSchema(EmailFolderSchema);

export const GetFolderResponseSchema = EmailFolderSchema;

export const CreateFolderResponseSchema = EmailFolderSchema;

export const UpdateFolderResponseSchema = EmailFolderSchema;

export const DeleteFolderResponseSchema = Type.Null();

export type GetFoldersListResponse = Static<typeof GetFoldersListResponseSchema>;
export type GetFolderResponse = Static<typeof GetFolderResponseSchema>;
export type CreateFolderResponse = Static<typeof CreateFolderResponseSchema>;
export type DeleteFolderResponse = Static<typeof DeleteFolderResponseSchema>;
export type UpdateFolderResponse = Static<typeof UpdateFolderResponseSchema>;
